import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gaeskeqmf8: FaireBrandEntity = {
  token: "b_gaeskeqmf8",
  type: "brand",
  name: "Flowerhint",
  avatarUrl:
    "https://cdn.faire.com/fastly/f427a965ad46fb0fa4e51eb6aeee1f4f5b224e683ba536fa4e2c8047481fa791.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/febd13b293cec6823f3957e5021c3aede0fc696af050f947bd8fe218b843daba.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f427a965ad46fb0fa4e51eb6aeee1f4f5b224e683ba536fa4e2c8047481fa791.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/febd13b293cec6823f3957e5021c3aede0fc696af050f947bd8fe218b843daba.png",
  location: "calgary, AB, CAN",
  minimumOrderDollars: 1378,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Experience world-class floral designs at Flowerhint. We offer premium flower delivery with free shipping worldwide. Handcrafted bouquets for every occasion. Shop stunning bouquets at Flowerhint.com! Enjoy global free shipping on all orders. Send fresh flowers worldwide for birthdays, anniversaries, & more. Shop now!\n\nFlowerhint was created to bring joy and warmth into people's lives by offering stunning floral arrangements that can be delivered worldwide. Our journey began with a love for nature's beauty, driving us to curate unique and premium floral designs for every occasion. From birthdays and anniversaries to a simple act of caring, our handcrafted bouquets truly make every moment special. We take pride in our commitment to quality and customer satisfaction, ensuring that every bouquet is a masterpiece, transcending mere flower arrangements to become an expression of love and care. Join us as we spread happiness one bouquet at a time.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.167Z",
    importedBy: "entity-db-cli",
  },
};
